/**
 * Procedural SFX (Fe).
 */
import { Ee } from "./engine.js";

export class Fe {
        engine;
        constructor(e) {
            this.engine = e
        }
        get ctx() {
            return this.engine.ctx
        }
        envelope(e, t, n, r) {
            let i = this.ctx.createGain();
            return i.gain.value = 0, i.gain.setValueAtTime(1e-4, e), i.gain.exponentialRampToValueAtTime(Math.max(2e-4, t), e + n), i.gain.exponentialRampToValueAtTime(1e-4, e + r), i
        }
        out(e, t) {
            let n = this.ctx,
                r = e ?? this.engine.buses.sfx;
            if (t === void 0 || t === 0) return r;
            let i = n.createStereoPanner();
            return i.pan.value = Math.max(-1, Math.min(1, t)), i.connect(r), i
        }
        tone(e) {
            let t = this.ctx;
            if (!t || t.state !== `running`) return;
            let n = Math.max(t.currentTime, e.when ?? 0),
                r = t.createOscillator();
            r.type = e.type ?? `sine`, r.frequency.setValueAtTime(e.freq, n), e.freqEnd && r.frequency.exponentialRampToValueAtTime(Math.max(1, e.freqEnd), n + e.dur);
            let i = this.envelope(n, e.gain, e.attack ?? .004, e.dur),
                a = r;
            if (e.filter) {
                let n = t.createBiquadFilter();
                n.type = e.filter.type, n.frequency.value = e.filter.freq, n.Q.value = e.filter.Q ?? .7, a.connect(n), a = n
            }
            if (e.vibrato) {
                let i = t.createOscillator();
                i.frequency.value = e.vibrato.rate;
                let a = t.createGain();
                a.gain.value = e.vibrato.depth, i.connect(a).connect(r.frequency), i.start(n), i.stop(n + e.dur + .05)
            }
            a.connect(i).connect(this.out(e.dest, e.pan)), r.start(n), r.stop(n + e.dur + .05)
        }
        noise(e) {
            let t = this.ctx,
                n = this.engine.noise;
            if (!t || !n || t.state !== `running`) return;
            let r = Math.max(t.currentTime, e.when ?? 0),
                i = t.createBufferSource();
            i.buffer = n, i.playbackRate.value = .9 + Math.random() * .2;
            let a = t.createBiquadFilter();
            a.type = e.type ?? `bandpass`, a.frequency.setValueAtTime(e.freq, r), e.freqEnd && a.frequency.exponentialRampToValueAtTime(e.freqEnd, r + e.dur), a.Q.value = e.Q ?? 1;
            let o = this.envelope(r, e.gain, e.attack ?? .003, e.dur);
            i.connect(a).connect(o).connect(this.out(e.dest, e.pan));
            let s = Math.random() * (n.duration - e.dur - .1);
            i.start(r, Math.max(0, s), e.dur + .05)
        }
        withVerb(e, t, n = this.engine.buses.sfx) {
            let r = this.ctx;
            if (!r) return n;
            let i = r.createGain();
            if (i.connect(n), e) {
                let n = r.createGain();
                n.gain.value = t, i.connect(n).connect(this.engine.reverbs[e])
            }
            return i
        }
        spatial(e, t, n, r) {
            let i = this.ctx;
            if (!i) return;
            let a = i.createPanner();
            a.panningModel = `HRTF`, a.distanceModel = `inverse`, a.refDistance = r, a.rolloffFactor = 1.1, Ee(a, e), a.connect(this.withVerb(t, n, this.engine.buses.ambience));
            let o = i.createGain();
            return o.connect(a), o
        }
        footstep(e, t, n) {
            let r = this.ctx;
            if (!r) return;
            let i = (Math.random() - .5) * .3,
                a = n === `pipe`,
                o = this.withVerb(n, a ? .22 : .35),
                s = (.6 + t * .5) * (a ? .7 : 1);
            e === `dirt` ? (this.noise({
                dur: .09,
                gain: .16 * s,
                type: `lowpass`,
                freq: 900 + Math.random() * 400,
                Q: .6,
                pan: i,
                dest: o
            }), this.noise({
                dur: .05,
                gain: .05 * s,
                type: `bandpass`,
                freq: 2600 + Math.random() * 1200,
                Q: 2,
                pan: i,
                dest: o,
                when: r.currentTime + .012
            }), this.tone({
                freq: 90,
                freqEnd: 55,
                dur: .08,
                gain: .12 * s,
                pan: i,
                dest: o
            })) : e === `concrete` ? (this.noise({
                dur: .045,
                gain: .13 * s,
                type: `bandpass`,
                freq: 2200 + Math.random() * 900,
                Q: 1.3,
                pan: i,
                dest: o
            }), this.tone({
                freq: 140,
                freqEnd: 70,
                dur: .06,
                gain: .12 * s,
                pan: i,
                dest: o
            })) : (this.noise({
                dur: .12,
                gain: .12 * s,
                type: `bandpass`,
                freq: 900,
                freqEnd: 3200,
                Q: 2.5,
                pan: i,
                dest: o
            }), this.noise({
                dur: .2,
                gain: .05 * s,
                type: `highpass`,
                freq: 3500,
                Q: .5,
                pan: i,
                dest: o,
                when: r.currentTime + .03
            }), this.tone({
                freq: 120,
                freqEnd: 60,
                dur: .07,
                gain: .08 * s,
                pan: i,
                dest: o
            }))
        }
        jump(e) {
            let t = this.withVerb(e, .25);
            this.noise({
                dur: .22,
                gain: .07,
                type: `bandpass`,
                freq: 500,
                freqEnd: 1600,
                Q: 1.2,
                attack: .04,
                dest: t
            })
        }
        land(e, t, n) {
            this.footstep(e, 1 + t, n), this.tone({
                freq: 70,
                freqEnd: 40,
                dur: .16,
                gain: .18 * Math.min(1.5, .5 + t),
                dest: this.withVerb(n, .3)
            })
        }
        drip(e, t) {
            let n = this.spatial(e, t, .9, 3),
                r = 900 + Math.random() * 900;
            this.tone({
                freq: r * 1.6,
                freqEnd: r,
                dur: .08,
                gain: .14,
                dest: n
            }), Math.random() < .5 && this.tone({
                freq: r * 2.1,
                freqEnd: r * 1.4,
                dur: .05,
                gain: .05,
                when: this.engine.now + .06,
                dest: n
            })
        }
        cheer(e = 1) {
            let t = this.ctx;
            if (!t) return;
            let n = t.currentTime,
                r = this.engine.buses.ambience;
            for (let t of [700, 1150, 2400]) this.noise({
                dur: 1.6 * e,
                gain: .06 * e,
                type: `bandpass`,
                freq: t,
                Q: 3,
                attack: .25,
                when: n,
                dest: r,
                pan: (Math.random() - .5) * .6
            });
            let i = Math.round(7 * e);
            for (let t = 0; t < i; t++) {
                let t = 380 + Math.random() * 420;
                this.tone({
                    type: `triangle`,
                    freq: t,
                    freqEnd: t * (1.6 + Math.random() * .6),
                    dur: .45 + Math.random() * .6,
                    gain: .018 + Math.random() * .02,
                    attack: .08,
                    when: n + Math.random() * .5 * e,
                    vibrato: {
                        rate: 5 + Math.random() * 3,
                        depth: 12
                    },
                    filter: {
                        type: `bandpass`,
                        freq: 900 + Math.random() * 600,
                        Q: 1.2
                    },
                    dest: r,
                    pan: (Math.random() - .5) * 1.6
                })
            }
        }
        owl(e) {
            let t = this.ctx;
            if (!t || t.state !== `running`) return;
            let n = this.spatial(e, null, 0, 14),
                r = 360 + Math.random() * 70,
                i = (e, t, i, a, o, s = 0) => this.tone({
                    freq: r * i,
                    freqEnd: r * a,
                    dur: t,
                    gain: o,
                    attack: .07,
                    when: e,
                    dest: n,
                    filter: {
                        type: `lowpass`,
                        freq: 1300
                    },
                    vibrato: s ? {
                        rate: 9,
                        depth: s
                    } : void 0
                }),
                a = t.currentTime + .05;
            i(a, .6, 1.04, .93, .5);
            let o = a + 2.1 + Math.random() * .8;
            i(o, .14, .99, .95, .28), i(o + .24, 1, 1.05, .9, .45, 8)
        }
        twig(e) {
            let t = this.ctx;
            if (!t) return;
            let n = this.spatial(e, null, 0, 5),
                r = t.currentTime + .02;
            this.noise({
                dur: .035,
                gain: .55,
                type: `bandpass`,
                freq: 2200 + Math.random() * 1600,
                Q: 1.8,
                when: r,
                dest: n
            }), this.tone({
                freq: 190,
                freqEnd: 80,
                dur: .05,
                gain: .25,
                when: r,
                dest: n
            }), this.noise({
                dur: .025,
                gain: .3,
                type: `bandpass`,
                freq: 3300,
                Q: 2.2,
                when: r + .05 + Math.random() * .08,
                dest: n
            }), this.noise({
                dur: .45,
                gain: .07,
                type: `highpass`,
                freq: 2800,
                attack: .06,
                when: r + .03,
                dest: n
            })
        }
        creak(e) {
            let t = this.ctx;
            if (!t || t.state !== `running`) return;
            let n = this.spatial(e, null, 0, 8),
                r = t.currentTime + .02,
                i = .8 + Math.random() * 1.1,
                a = 48 + Math.random() * 40,
                o = t.createOscillator();
            o.type = `sawtooth`, o.frequency.setValueAtTime(a, r), o.frequency.linearRampToValueAtTime(a * (.75 + Math.random() * .6), r + i);
            let s = t.createBiquadFilter();
            s.type = `bandpass`, s.frequency.value = 650 + Math.random() * 500, s.Q.value = 2.5;
            let c = t.createGain();
            c.gain.value = .5;
            let l = t.createOscillator();
            l.type = `square`, l.frequency.setValueAtTime(14 + Math.random() * 16, r), l.frequency.linearRampToValueAtTime(10 + Math.random() * 20, r + i);
            let u = t.createGain();
            u.gain.value = .5, l.connect(u).connect(c.gain);
            let d = t.createGain();
            d.gain.setValueAtTime(0, r), d.gain.linearRampToValueAtTime(.24, r + i * .3), d.gain.linearRampToValueAtTime(.18, r + i * .7), d.gain.linearRampToValueAtTime(0, r + i), o.connect(s).connect(c).connect(d).connect(n), o.start(r), l.start(r), o.stop(r + i + .05), l.stop(r + i + .05)
        }
        gust(e = 1) {
            let t = this.ctx,
                n = this.engine.brown;
            if (!t || !n || t.state !== `running`) return;
            let r = t.currentTime + .02,
                i = 5 + Math.random() * 4,
                a = r + i * (.4 + Math.random() * .2),
                o = t.createBufferSource();
            o.buffer = n, o.loop = !0;
            let s = t.createBiquadFilter();
            s.type = `bandpass`, s.Q.value = .9, s.frequency.setValueAtTime(140, r), s.frequency.linearRampToValueAtTime(260 + 160 * e, a), s.frequency.linearRampToValueAtTime(130, r + i);
            let c = t.createBiquadFilter();
            c.type = `lowpass`, c.frequency.value = 700;
            let l = t.createGain();
            l.gain.setValueAtTime(0, r), l.gain.linearRampToValueAtTime(.16 * e, a), l.gain.linearRampToValueAtTime(0, r + i);
            let u = t.createStereoPanner(),
                d = Math.random() < .5 ? -1 : 1;
            u.pan.setValueAtTime(-.6 * d, r), u.pan.linearRampToValueAtTime(.6 * d, r + i), o.connect(s).connect(c).connect(l).connect(u).connect(this.engine.buses.ambience), o.start(r, Math.random() * 2), o.stop(r + i + .1)
        }
        clank(e) {
            let t = this.spatial(e, `pipe`, 1.2, 5),
                n = 170 + Math.random() * 110,
                r = this.engine.now + .02;
            [1, 2.76, 5.4, 8.93].forEach((e, i) => this.tone({
                freq: n * e,
                dur: 1.3 / (1 + i * .6),
                gain: .2 / (1 + i),
                when: r,
                dest: t
            })), this.noise({
                dur: .03,
                gain: .25,
                type: `bandpass`,
                freq: 3e3,
                Q: 1,
                when: r,
                dest: t
            }), Math.random() < .5 && [1, 2.76, 5.4].forEach((e, i) => this.tone({
                freq: n * 1.06 * e,
                dur: .8 / (1 + i * .6),
                gain: .1 / (1 + i),
                when: r + .28,
                dest: t
            }))
        }
        uiHover() {
            this.tone({
                freq: 2600,
                dur: .025,
                gain: .03,
                dest: this.engine.buses.ui,
                type: `sine`
            })
        }
        uiSelect() {
            let e = this.engine.now;
            this.tone({
                freq: 660,
                dur: .07,
                gain: .07,
                when: e,
                dest: this.engine.buses.ui,
                type: `triangle`
            }), this.tone({
                freq: 990,
                dur: .1,
                gain: .07,
                when: e + .05,
                dest: this.engine.buses.ui,
                type: `triangle`
            })
        }
        uiBack() {
            let e = this.engine.now;
            this.tone({
                freq: 740,
                dur: .07,
                gain: .06,
                when: e,
                dest: this.engine.buses.ui,
                type: `triangle`
            }), this.tone({
                freq: 494,
                dur: .1,
                gain: .06,
                when: e + .05,
                dest: this.engine.buses.ui,
                type: `triangle`
            })
        }
        done() {
            let e = this.engine.now;
            this.tone({
                freq: 1047,
                dur: .18,
                gain: .05,
                when: e,
                dest: this.engine.buses.ui,
                type: `triangle`
            }), this.tone({
                freq: 1568,
                dur: .25,
                gain: .05,
                when: e + .08,
                dest: this.engine.buses.ui,
                type: `triangle`
            })
        }
        shutter() {
            this.noise({
                dur: .05,
                gain: .2,
                type: `highpass`,
                freq: 2500,
                dest: this.engine.buses.ui
            }), this.noise({
                dur: .06,
                gain: .15,
                type: `highpass`,
                freq: 2e3,
                when: this.engine.now + .08,
                dest: this.engine.buses.ui
            })
        }
}

export { Fe as Sfx };
